import { render } from "./Proofreader.vue?vue&type=template&id=9b506a0a&scoped=true&ts=true"
import script from "./Proofreader.vue?vue&type=script&lang=ts"
export * from "./Proofreader.vue?vue&type=script&lang=ts"

import "./Proofreader.vue?vue&type=style&index=0&id=9b506a0a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b506a0a"]])

export default __exports__